import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { SocketState } from "../../../context/SocketProvider";
import { selectPanelWithInput, selectPointList } from "../../../redux/3d_game_Slice/panelSlice";
import { selectTimeSlot, setAdvanceTimeSlotCount, setSelectTimeSlot } from "../../../redux/seriesSlice";
import "./resultPopUp.scss";
import { selectAllTimeSlot3d } from "../../../redux/3d_game_Slice/gameinfo3d";
import ModalContainer from "../../../2d-game/modals/ModalContainer";
import Checkbox4 from "../../../2d-game/componenent/checkbox/Checkbox4";

function AdvanceDrawPopup3d() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { socket } = SocketState();

  let allTimeSlot = useSelector(selectAllTimeSlot3d);
  let pointList = useSelector(selectPointList)
  const panelWithInput = useSelector(selectPanelWithInput)
  let checkTimeSlots = useSelector(selectTimeSlot)


  const [timeSlot, setTimeSlot] = useState([]);
  const [selectCount, setSelectCount] = useState(null);
  const [alpha, setAlpha] = useState("ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""))
  const [selectAllFlag, setSelectAllFlag] = useState(false)

  useEffect(() => {
    var data = {
      en: "PICK_THREE_ADVANCE_DRAW_TIME_SLOT",
      data: {},
    };
    socket.emit("req", data);
    return () => {
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    }
  }, [])

  useEffect(() => {
    if (allTimeSlot.length) {

      let timeArray = JSON.parse(JSON.stringify(allTimeSlot)).map((time) => {

        if (time.status === 'completed') {
          time.disable = true;
        } else {
          time.disable = false
        }
        if (checkTimeSlots.includes(time.time)) {
          time.select = true
        } else {
          time.select = false;
        }
        return time;
      });
      setTimeSlot(timeArray);
    }
  }, [allTimeSlot]);

  // select count
  useEffect(() => {
    if (timeSlot.length) {
      let copytimeArray = [...timeSlot];
      for (let index = 0; index < copytimeArray.length; index++) {
        copytimeArray[index].select = false;
      }
      if (selectAllFlag) {
        let findIndex = copytimeArray.findIndex((time) => !time.disable);
        let count = Number(findIndex) + Number(copytimeArray.length);
        for (let index = findIndex; index < count; index++) {
          if (copytimeArray[index]) {
            copytimeArray[index].select = true;
          }
        }
      }
      setSelectCount(null)
      setTimeSlot(copytimeArray);
    }
  }, [selectAllFlag]);

  useEffect(() => {
    if (timeSlot.length) {
      let copytimeArray = [...timeSlot];
      for (let index = 0; index < copytimeArray.length; index++) {
        copytimeArray[index].select = false;
      }
      if (selectCount) {
        let findIndex = copytimeArray.findIndex((time) => !time.disable);
        let count = Number(findIndex) + Number(selectCount);
        for (let index = findIndex; index < count; index++) {
          if (copytimeArray[index]) {
            copytimeArray[index].select = true;
          }
        }
      }
      setTimeSlot(copytimeArray);
    }
  }, [selectCount]);

  useEffect(() => {
    if (timeSlot.length) {
      let filter = timeSlot.filter(data => data.select)
      if (filter.length) {
        dispatch(setAdvanceTimeSlotCount(filter.length))
      }
    }
  }, [timeSlot, dispatch])

  let submit = () => {
    let selectTimeFilter = []
    timeSlot.forEach((time) => {
      if (time.select) {
        selectTimeFilter.push(time.time)
      }
    })
    dispatch(setSelectTimeSlot(selectTimeFilter))
    navigate(`/3D`);
  };

  return (
    <>
      <ModalContainer title={'Advance Draw'} navigation={'/3d'}>
        <div className='flex w-[90%] mx-auto flex-wrap h-[calc(100vh-40vh)] overflow-y-auto'>
          {timeSlot?.map((time, index) => (
            <div
              key={index}
              className="
                  w-1/6 px-1 py-1.5
                  sm:w-1/4      /* 4 columns on small screens */
                  xs:w-1/3      /* 3 columns on extra small screens */
                  max-[480px]:w-1/2   /* 2 columns on very small mobile */
                "
            >
              <div
                className={`border-2 py-2 rounded-lg border-gray-300 flex items-center justify-center gap-2 cursor-pointer 
                  ${time.disable ? 'bg-gray-400' : 'bg-white'}`}
              >
                <Checkbox4
                  disabled={time.disable}
                  checked={time.select}
                  onChange={(e) => {
                    const copyTimeSlot = [...timeSlot];
                    copyTimeSlot[index].select = e.target.checked;
                    setTimeSlot([...copyTimeSlot]);
                  }}
                />
                <p className="font-semibold text-[17px]">{time.time}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="absolute bottom-0 left-0 w-full pb-4 px-2 bg-white border-t border-gray-200">
          <div className='flex justify-center items-center mb-4'>
            <p className='font-semibold mr-4 text-[18px]'>No of Draws</p>
            <input
              className={`shadow appearance-none border border-black rounded w-[80px] py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-center mr-4 ${selectAllFlag ? 'cursor-not-allowed' : 'cursor-text'}`}
              type="text"
              value={selectCount ? selectCount : ''}
              onChange={(e) => setSelectCount(e.target.value)}
              disabled={!!selectAllFlag}
            />

            <div className='flex'><Checkbox4 checked={selectAllFlag} onChange={(e) => setSelectAllFlag(e.target.checked)} /> <p className='font-semibold text-[17px]'>Select All</p></div>
          </div>

          <div className='flex justify-center'>
            <div className='w-1/5 px-1'><button className='text-center w-full rounded-lg py-3 bg-[#374566] text-[white] font-semibold'
              onClick={() => {
                let copytimeArray = [...timeSlot];
                let updateValue = copytimeArray.map((time) => {
                  time.select = false;
                });
                setTimeSlot(copytimeArray);
                setSelectCount(null);

              }}
            >CLEAR</button></div>
            <div className='w-1/5 px-1'><button className='text-center w-full rounded-lg py-3 bg-[#374566] text-[white] font-semibold' onClick={() => navigate('/3d')}>CANCEL</button></div>
            <div className='w-1/5 px-1'><button className='text-center w-full rounded-lg py-3 bg-[#e54859] text-[white] font-semibold'
              onClick={submit}
            >OK</button></div>

          </div>
        </div>
      </ModalContainer>
      {/* <div
        className="modal fade show block absolute"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl" style={{ margin: "0", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
          <div className="modal-content relative" style={{ minHeight: "100%", height: "100%", width: "100%", overflow: "unset", background: "transparent" }}>
            <button
              type="button"
              aria-label="Close"
              className="btn-close"
              onClick={() => {
                navigate(`/3d`);;
              }}
              style={{
                position: "absolute",
                right: "10px",
                top: "8px",
                height: "20px",
                width: "20px",
                backgroundColor: "#47fff3",
                color: "#fff",
                opacity: 1,
                fontSize: "14px",
                borderRadius: "6px",
                filter: "invert(1)",
                boxShadow: "none",
              }}
            ></button>
            <div className='black-section pb-0' style={{ padding: "20px", height: "100%" }}>
              <div className="popup-inner">
                <div className="flex flex-wrap">
                  {timeSlot?.map((time, index) => {
                    return (
                      <div
                        className={`box-inner-checkbox ${time.disable && "disable-color"
                          }`}
                        key={index}
                      >
                        <div className="font-bold flex align-items-center">
                          <input
                            type="checkbox"
                            className="me-2 checkbox-custom-wrapper"
                            disabled={time.disable}
                            checked={time.select}
                            onChange={(e) => {
                              let copyTimeSlot = [...timeSlot];
                              copyTimeSlot[index].select = e.target.checked;
                              setTimeSlot([...timeSlot]);
                            }}
                          />
                          {time.time}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="botom-input">
                  <div className="flex">
                    <div className="text-center color-box-blue ap-input-wrapper">
                      <input
                        type="number"
                        className="form-control input-box-wrapper text-black c-input-footer input-advance"
                        value={selectCount ? selectCount : ''}
                        onChange={(e) => setSelectCount(e.target.value)}
                      />
                    </div>
                    <div>
                      <button
                        id="advancePrintBtn"
                        className="btn-light btn ap-btn ms-2"
                        onClick={submit}
                      >
                        Ok
                      </button>
                    </div>
                    <div>
                      {" "}
                      <button
                        className="btn-light btn ap-btn ms-2"
                        onClick={() => {
                          let copytimeArray = [...timeSlot];
                          let updateValue = copytimeArray.map((time) => {
                            time.select = false;
                          });
                          setTimeSlot(copytimeArray);
                          setSelectCount(null);
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div> */}
    </>
  );
}

export default AdvanceDrawPopup3d;
